import { Modal } from 'antd';
import VisionCam from '../VisionCam';
import { useState } from 'react';
import { Group } from '@/components/_common';
import { useColorScheme } from '@/contexts/ColorSchemeContextProvider';
import VisionWorkorders from '../VisionWorkorders';
import './styles.less';

interface Props {
  opened: boolean;
  onClose: VoidFunction;
}

export default function VisionModal(props: Props) {
  const [colorScheme] = useColorScheme();

  const [licensePlate, setLicensePlate] = useState<string>();

  const handleClose = () => {
    setLicensePlate(undefined);
    props.onClose();
  };

  return (
    <Modal
      open={props.opened}
      onCancel={handleClose}
      width={1000}
      maskClosable={false}
      footer={null}
      className="vision-modal"
      maskStyle={{ backdropFilter: 'blur(5px)' }}
      destroyOnClose
    >
      <Group position="center" style={{ marginBottom: 24 }} gap={4}>
        <img
          src="/images/UltraVision.png"
          alt="logo"
          key={colorScheme}
          style={{
            height: '1.5rem',
            pointerEvents: 'none',
          }}
          draggable="false"
        />
      </Group>

      <div style={{ marginBottom: 24, display: 'block' }}>
        <VisionCam
          onChangeLicensePlate={setLicensePlate}
          key={Number(props.opened)}
        />
      </div>

      <VisionWorkorders licensePlate={licensePlate} />
    </Modal>
  );
}
